import { Button, Modal } from "@legal-500/legal500-design-system";
import { useState } from "react";
import { dbManagerService } from "../../../api/dbManager.service.js";
import styles from "./DbManager.module.css";

type DiscardModalProps = {
  isOpen: boolean;
  keyspace: string;
  family: string;
  onClose: () => void;
  onDiscarded: () => void;
};

export function DiscardModal({
  isOpen,
  keyspace,
  family,
  onClose,
  onDiscarded,
}: DiscardModalProps) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await dbManagerService.discardKeyspace(keyspace, family);
      onDiscarded();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Discard slot ${keyspace}`}
      size="small"
      blurBackground
    >
      <div className={styles.modalBody}>
        {error && <div className={styles.errorBanner}>{error}</div>}

        <p>
          This will clear all keys for slot <code>{keyspace}</code> and keep it registered as empty.
          Use remove if you want to delete the slot from the directory entirely. Cannot be undone.
        </p>

        <div className={styles.actions}>
          <Button variant="text" color="default" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleConfirm} disabled={submitting}>
            {submitting ? "Discarding..." : "Discard"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
